<template>
  <div class="row collapsible-body">
    <form id="passengers" class="col s12">
      <h4 class="header col s12 light">Coordonnées</h4>

      <div class="input-field col s12 m6">
        <input id="telephone" type="text" minlength="10" class="validate" v-model="phone"
          pattern="^[0-9. _\/+-]{8,20}$" />
        <label for="telephone">Téléphone</label>
        <span class="helper-text" data-error="Merci de saisir un numéro de téléphone valide"></span>
      </div>
      <div class="input-field col s12 m6">
        <input id="email" type="email" class="validate" v-model="mail"
          pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,10}$" />
        <label for="email">Adresse email</label>
        <span class="helper-text" data-error="Merci de saisir une adresse email valide"></span>
      </div>

      <div :key="id" v-for="(num, id) in place">
        <h4 class="header col s12 light">{{ numPassenger(num) }} passager</h4>

        <div class="input-field col s12 m4">
          <input :id="'lastname[' + id + ']'" type="text" minlength="2" maxlength="50" onkeyup="this.value=this.value.toUpperCase(); show(this.id)" class="validate"
          pattern="^[A-z-\s]{2,50}$" 
            v-model="passengers.lastname[id]" />
          <label :for="'lastname[' + id + ']'">Nom</label>
          <span class="helper-text" data-error="Merci de saisir le nom de famille (caractères spéciaux interdit)"></span>
        </div>

        <div class="input-field col s12 m4">
          <input :id="'firstname[' + id + ']'" type="text" minlength="2" maxlength="50" style="text-transform: uppercase" class="validate"
            pattern="^[A-zÀ-ÿ-\s]{2,50}$" 
            v-model="passengers.firstname[id]" />
          <label :for="'firstname[' + id + ']'">Prénom</label>
          <span class="helper-text" data-error="Merci de saisir le prénom (caractères spéciaux interdit)"></span>
        </div>

        <div class="input-field col s6 m4 scale-transition">
          <InputDateBirth :id="'birthday[' + id + ']'" type="text" minlength="2" class="validate"
            pattern="^[0-9\/]{10,10}$" 
            v-model="passengers.birthday[id]" />
          <label :for="'birthday[' + id + ']'">Date de naissance</label>
          <span class="helper-text" data-error="Merci de saisir une date de naissance valide"></span>
        </div>

        <div class="input-field col s12 m4">
         <label :for="'nationalite[' + id + ']'">Nationalité</label><br><br>
            <select id="'nationalite[' + id + ']'" class="browser-default" v-model="passengers.nationality[id]" >
              <option value="AF">Afghanistan</option>
              <option value="ZA">Afrique du Sud</option>
              <option value="AL">Albanie</option>
              <option value="DZ">Algérie</option>
              <option value="DE">Allemagne</option>
              <option value="AD">Andorre</option>
              <option value="AO">Angola</option>
              <option value="AI">Anguille</option>
              <option value="AQ">Antarctique</option>
              <option value="AG">Antigua-et-Barbuda</option>
              <option value="SA">Arabie Saoudite</option>
              <option value="AR">Argentine</option>
              <option value="AM">Arménie</option>
              <option value="AW">Aruba</option>
              <option value="AU">Australie</option>
              <option value="AT">Autriche</option>
              <option value="AZ">Azerbaïdjan</option>
              <option value="BS">Bahamas</option>
              <option value="BH">Bahreïn</option>
              <option value="BD">Bangladesh</option>
              <option value="BB">Barbes</option>
              <option value="BE">Belgique</option>
              <option value="BZ">Bélize</option>
              <option value="BJ">Bénin</option>
              <option value="BM">Bermudes</option>
              <option value="BT">Bhoutan</option>
              <option value="BY">Biélorussie</option>
              <option value="MM">Birmanie</option>
              <option value="BO">Bolivie (État plurinational de)</option>
              <option value="BQ">Bonaire, Saint-Eustache et Saba</option>
              <option value="BA">Bosnie-Herzégovine</option>
              <option value="BW">Botswana</option>
              <option value="BR">Brésil</option>
              <option value="BN">Brunei Darussalam</option>
              <option value="BG">Bulgarie</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="KH">Cambodge</option>
              <option value="CM">Cameroun</option>
              <option value="CA">Canada</option>
              <option value="CV">Cap Vert</option>
              <option value="CL">Chili</option>
              <option value="CN">Chine</option>
              <option value="CY">Chypre</option>
              <option value="CO">Colombie</option>
              <option value="KM">Comores</option>
              <option value="CD">Congo (République Démocratique du Congo)</option>
              <option value="CG">Congo</option>
              <option value="KR">Corée (République de)</option>
              <option value="KP">Corée (République populaire démocratique de Corée)</option>
              <option value="CR">Costa Rica</option>
              <option value="CI">Côte d'Ivoire</option>
              <option value="HR">Croatie</option>
              <option value="CU">Cuba</option>
              <option value="CW">Curaçao</option>
              <option value="DK">Danemark</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominique</option>
              <option value="EG">Égypte</option>
              <option value="AE">Emirats Arabes Unis</option>
              <option value="CE">Équateur</option>
              <option value="ER">Érythrée</option>
              <option value="ES">Espagne</option>
              <option value="OUI">Estonie</option>
              <option value="US">États-Unis d'Amérique</option>
              <option value="ET">Éthiopie</option>
              <option value="RU">Fédération de Russie</option>
              <option value="FJ">Fidji</option>
              <option value="FI">Finlande</option>
              <option value="FR">France</option>
              <option value="GA">Gabon</option>
              <option value="GM">Gambie</option>
              <option value="GS">Géorgie du Sud et îles Sandwich du Sud</option>
              <option value="GE">Géorgie</option>
              <option value="GH">Ghana</option>
              <option value="GI">Gibraltar</option>
              <option value="GR">Grèce</option>
              <option value="GD">Grenade</option>
              <option value="GL">Groenland</option>
              <option value="GP">Guadeloupe</option>
              <option value="GU">Guam</option>
              <option value="GT">Guatemala</option>
              <option value="GG">Guernesey</option>
              <option value="GQ">Guinée équatoriale</option>
              <option value="GN">Guinée</option>
              <option value="GW">Guinée-Bissau</option>
              <option value="GF">Guyane française</option>
              <option value="GY">Guyane</option>
              <option value="HT">Haïti</option>
              <option value="HN">Honduras</option>
              <option value="HK">Hong Kong</option>
              <option value="HU">Hongrie</option>
              <option value="BV">Ile Bouvet</option>
              <option value="IM">Île de Man</option>
              <option value="HM">Île Heard et Îles McDonald</option>
              <option value="NF">Île Norfolk</option>
              <option value="AX">Îles Åland</option>
              <option value="KY">Îles Caïmans</option>
              <option value="CC">Îles Cocos (Keeling)</option>
              <option value="CK">Îles Cook</option>
              <option value="FK">Îles Falkland (Falkland)</option>
              <option value="FO">Îles Féroé</option>
              <option value="MP">Îles Mariannes du Nord</option>
              <option value="MH">Îles Marshall</option>
              <option value="UM">Îles mineures éloignées des États-Unis</option>
              <option value="SB">Îles Salomon</option>
              <option value="TC">Îles Turques et Caïques</option>
              <option value="VG">Iles Vierges (Britanniques)</option>
              <option value="WE">Îles Vierges (États-Unis)</option>
              <option value="IN">Inde</option>
              <option value="ID">Indonésie</option>
              <option value="IQ">Irak</option>
              <option value="IR">Iran (République islamique d')</option>
              <option value="IE">Irlande</option>
              <option value="EST">Islande</option>
              <option value="IL">Israël</option>
              <option value="IT">Italie</option>
              <option value="JM">Jamaïque</option>
              <option value="JP">Japon</option>
              <option value="JO">Jordanie</option>
              <option value="KZ">Kazakhstan</option>
              <option value="KG">Kirghizistan</option>
              <option value="KI">Kiribati</option>
              <option value="KW">Koweït</option>
              <option value="SV">Le Salvador</option>
              <option value="LS">Lesotho</option>
              <option value="LV">Lettonie</option>
              <option value="LB">Liban</option>
              <option value="LR">Libéria</option>
              <option value="LY">Libye</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lituanie</option>
              <option value="LU">Luxembourg</option>
              <option value="MO">Macao</option>
              <option value="MK">Macédoine (l'ex-République yougoslave de)</option>
              <option value="MG">Madagascar</option>
              <option value="MY">Malaysia</option>
              <option value="MW">Malawi</option>
              <option value="MV">Maldives</option>
              <option value="ML">Mali</option>
              <option value="MT">Malte</option>
              <option value="MA">Maroc</option>
              <option value="MQ">Martinique</option>
              <option value="MU">Maurice</option>
              <option value="MR">Mauritanie</option>
              <option value="YT">Mayotte</option>
              <option value="MX">Mexique</option>
              <option value="FM">Micronésie (États fédérés d'Amérique)</option>
              <option value="MD">Moldavie (République de)</option>
              <option value="MC">Monaco</option>
              <option value="MN">Mongolie</option>
              <option value="ME">Monténégro</option>
              <option value="MS">Montserrat</option>
              <option value="MZ">Mozambique</option>
              <option value="NA">Namibie</option>
              <option value="NR">Nauru</option>
              <option value="NP">Népal</option>
              <option value="NI">Nicaragua</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NON">Norvège</option>
              <option value="NC">Nouvelle-Calédonie</option>
              <option value="NZ">Nouvelle-Zélande</option>
              <option value="OM">Oman</option>
              <option value="UG">Ouganda</option>
              <option value="UZ">Ouzbékistan</option>
              <option value="PK">Pakistan</option>
              <option value="PW">Palaos</option>
              <option value="PS">Palestine, État de</option>
              <option value="PA">Panamá</option>
              <option value="PG">Papouasie-Nouvelle-Guinée</option>
              <option value="PY">Paraguay</option>
              <option value="NL">Pays-Bas</option>
              <option value="PE">Pérou</option>
              <option value="PH">Philippines</option>
              <option value="PN">Pitcairn</option>
              <option value="PL">Pologne</option>
              <option value="PF">Polynésie française</option>
              <option value="PR">Porto Rico</option>
              <option value="PT">Portugal</option>
              <option value="QA">Qatar</option>
              <option value="RE">Réunion</option>
              <option value="SY">République arabe syrienne</option>
              <option value="CF">République centrafricaine</option>
              <option value="LA">République démocratique populaire lao</option>
              <option value="DO">République dominicaine</option>
              <option value="CZ">République tchèque</option>
              <option value="RO">Roumanie</option>
              <option value="GB">Royaume-Uni de Grande-Bretagne et d'Irlande du Nord</option>
              <option value="RW">Rwanda</option>
              <option value="EH">Sahara Occidenta</option>
              <option value="BL">Saint Barthélemy</option>
              <option value="SH">Sainte Hélène, Ascension et Tristan da Cunha</option>
              <option value="LC">Sainte-Lucie</option>
              <option value="KN">Saint-Kitts-et-Nevis</option>
              <option value="SM">Saint-Marin</option>
              <option value="MF">Saint-Martin (partie française)</option>
              <option value="PM">Saint-Pierre et Miquelon</option>
              <option value="VA">Saint-Siège</option>
              <option value="VC">Saint-Vincent-et-les Grenadines</option>
              <option value="AS">Samoa américaines</option>
              <option value="WS">Samoa</option>
              <option value="ST">Sao Tomé et Principe</option>
              <option value="SN">Sénégal</option>
              <option value="RS">Serbie</option>
              <option value="SC">Seychelles</option>
              <option value="SL">Sierra Leone</option>
              <option value="SG">Singapour</option>
              <option value="SX">Sint Maarten (partie néerlandaise)</option>
              <option value="SK">Slovaquie</option>
              <option value="SI">Slovénie</option>
              <option value="SO">Somalie</option>
              <option value="SS">Soudan du Sud</option>
              <option value="SD">Soudan</option>
              <option value="LK">Sri Lanka</option>
              <option value="SE">Suède</option>
              <option value="CH">Suisse</option>
              <option value="SR">Surinam</option>
              <option value="SJ">Svalbard et la mer</option>
              <option value="SZ">Swaziland</option>
              <option value="TJ">Tadjikistan</option>
              <option value="TW">Taïwan, province de Chine[a]</option>
              <option value="TZ">Tanzanie, République-Unie de</option>
              <option value="TD">Tchad</option>
              <option value="TF">Terres Australes Françaises</option>
              <option value="IO">Territoire britannique de l'océan Indien</option>
              <option value="TH">Thaïlande</option>
              <option value="TL">Timor oriental</option>
              <option value="TG">Togo</option>
              <option value="TT">Trinité-et-Tobago</option>
              <option value="TN">Tunisie</option>
              <option value="TM">Turkménistan</option>
              <option value="TR">Turquie</option>
              <option value="TV">Tuvalu</option>
              <option value="UA">Ukraine</option>
              <option value="UY">Uruguay</option>
              <option value="VU">Vanuatu</option>
              <option value="VE">Venezuela (République bolivarienne du)</option>
              <option value="VN">Viet Nam</option>
              <option value="WF">Wallis et Futuna</option>
              <option value="YE">Yémen</option>
              <option value="ZM">Zambie</option>
              <option value="ZW">Zimbabwe</option>
            </select>
        </div>

        <div class="input-field col s12 m4">
          <label>Pays de naissance</label><br><br>
            <select id="'paysnaissance[' + id + ']'" class="browser-default" v-model="passengers.paysnaissance[id]" >
              <option value="AF">Afghanistan</option>
              <option value="ZA">Afrique du Sud</option>
              <option value="AL">Albanie</option>
              <option value="DZ">Algérie</option>
              <option value="DE">Allemagne</option>
              <option value="AD">Andorre</option>
              <option value="AO">Angola</option>
              <option value="AI">Anguille</option>
              <option value="AQ">Antarctique</option>
              <option value="AG">Antigua-et-Barbuda</option>
              <option value="SA">Arabie Saoudite</option>
              <option value="AR">Argentine</option>
              <option value="AM">Arménie</option>
              <option value="AW">Aruba</option>
              <option value="AU">Australie</option>
              <option value="AT">Autriche</option>
              <option value="AZ">Azerbaïdjan</option>
              <option value="BS">Bahamas</option>
              <option value="BH">Bahreïn</option>
              <option value="BD">Bangladesh</option>
              <option value="BB">Barbes</option>
              <option value="BE">Belgique</option>
              <option value="BZ">Bélize</option>
              <option value="BJ">Bénin</option>
              <option value="BM">Bermudes</option>
              <option value="BT">Bhoutan</option>
              <option value="BY">Biélorussie</option>
              <option value="MM">Birmanie</option>
              <option value="BO">Bolivie (État plurinational de)</option>
              <option value="BQ">Bonaire, Saint-Eustache et Saba</option>
              <option value="BA">Bosnie-Herzégovine</option>
              <option value="BW">Botswana</option>
              <option value="BR">Brésil</option>
              <option value="BN">Brunei Darussalam</option>
              <option value="BG">Bulgarie</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="KH">Cambodge</option>
              <option value="CM">Cameroun</option>
              <option value="CA">Canada</option>
              <option value="CV">Cap Vert</option>
              <option value="CL">Chili</option>
              <option value="CN">Chine</option>
              <option value="CY">Chypre</option>
              <option value="CO">Colombie</option>
              <option value="KM">Comores</option>
              <option value="CD">Congo (République Démocratique du Congo)</option>
              <option value="CG">Congo</option>
              <option value="KR">Corée (République de)</option>
              <option value="KP">Corée (République populaire démocratique de Corée)</option>
              <option value="CR">Costa Rica</option>
              <option value="CI">Côte d'Ivoire</option>
              <option value="HR">Croatie</option>
              <option value="CU">Cuba</option>
              <option value="CW">Curaçao</option>
              <option value="DK">Danemark</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominique</option>
              <option value="EG">Égypte</option>
              <option value="AE">Emirats Arabes Unis</option>
              <option value="CE">Équateur</option>
              <option value="ER">Érythrée</option>
              <option value="ES">Espagne</option>
              <option value="OUI">Estonie</option>
              <option value="US">États-Unis d'Amérique</option>
              <option value="ET">Éthiopie</option>
              <option value="RU">Fédération de Russie</option>
              <option value="FJ">Fidji</option>
              <option value="FI">Finlande</option>
              <option value="FR">France</option>
              <option value="GA">Gabon</option>
              <option value="GM">Gambie</option>
              <option value="GS">Géorgie du Sud et îles Sandwich du Sud</option>
              <option value="GE">Géorgie</option>
              <option value="GH">Ghana</option>
              <option value="GI">Gibraltar</option>
              <option value="GR">Grèce</option>
              <option value="GD">Grenade</option>
              <option value="GL">Groenland</option>
              <option value="GP">Guadeloupe</option>
              <option value="GU">Guam</option>
              <option value="GT">Guatemala</option>
              <option value="GG">Guernesey</option>
              <option value="GQ">Guinée équatoriale</option>
              <option value="GN">Guinée</option>
              <option value="GW">Guinée-Bissau</option>
              <option value="GF">Guyane française</option>
              <option value="GY">Guyane</option>
              <option value="HT">Haïti</option>
              <option value="HN">Honduras</option>
              <option value="HK">Hong Kong</option>
              <option value="HU">Hongrie</option>
              <option value="BV">Ile Bouvet</option>
              <option value="IM">Île de Man</option>
              <option value="HM">Île Heard et Îles McDonald</option>
              <option value="NF">Île Norfolk</option>
              <option value="AX">Îles Åland</option>
              <option value="KY">Îles Caïmans</option>
              <option value="CC">Îles Cocos (Keeling)</option>
              <option value="CK">Îles Cook</option>
              <option value="FK">Îles Falkland (Falkland)</option>
              <option value="FO">Îles Féroé</option>
              <option value="MP">Îles Mariannes du Nord</option>
              <option value="MH">Îles Marshall</option>
              <option value="UM">Îles mineures éloignées des États-Unis</option>
              <option value="SB">Îles Salomon</option>
              <option value="TC">Îles Turques et Caïques</option>
              <option value="VG">Iles Vierges (Britanniques)</option>
              <option value="WE">Îles Vierges (États-Unis)</option>
              <option value="IN">Inde</option>
              <option value="ID">Indonésie</option>
              <option value="IQ">Irak</option>
              <option value="IR">Iran (République islamique d')</option>
              <option value="IE">Irlande</option>
              <option value="EST">Islande</option>
              <option value="IL">Israël</option>
              <option value="IT">Italie</option>
              <option value="JM">Jamaïque</option>
              <option value="JP">Japon</option>
              <option value="JO">Jordanie</option>
              <option value="KZ">Kazakhstan</option>
              <option value="KG">Kirghizistan</option>
              <option value="KI">Kiribati</option>
              <option value="KW">Koweït</option>
              <option value="SV">Le Salvador</option>
              <option value="LS">Lesotho</option>
              <option value="LV">Lettonie</option>
              <option value="LB">Liban</option>
              <option value="LR">Libéria</option>
              <option value="LY">Libye</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lituanie</option>
              <option value="LU">Luxembourg</option>
              <option value="MO">Macao</option>
              <option value="MK">Macédoine (l'ex-République yougoslave de)</option>
              <option value="MG">Madagascar</option>
              <option value="MY">Malaysia</option>
              <option value="MW">Malawi</option>
              <option value="MV">Maldives</option>
              <option value="ML">Mali</option>
              <option value="MT">Malte</option>
              <option value="MA">Maroc</option>
              <option value="MQ">Martinique</option>
              <option value="MU">Maurice</option>
              <option value="MR">Mauritanie</option>
              <option value="YT">Mayotte</option>
              <option value="MX">Mexique</option>
              <option value="FM">Micronésie (États fédérés d'Amérique)</option>
              <option value="MD">Moldavie (République de)</option>
              <option value="MC">Monaco</option>
              <option value="MN">Mongolie</option>
              <option value="ME">Monténégro</option>
              <option value="MS">Montserrat</option>
              <option value="MZ">Mozambique</option>
              <option value="NA">Namibie</option>
              <option value="NR">Nauru</option>
              <option value="NP">Népal</option>
              <option value="NI">Nicaragua</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NON">Norvège</option>
              <option value="NC">Nouvelle-Calédonie</option>
              <option value="NZ">Nouvelle-Zélande</option>
              <option value="OM">Oman</option>
              <option value="UG">Ouganda</option>
              <option value="UZ">Ouzbékistan</option>
              <option value="PK">Pakistan</option>
              <option value="PW">Palaos</option>
              <option value="PS">Palestine, État de</option>
              <option value="PA">Panamá</option>
              <option value="PG">Papouasie-Nouvelle-Guinée</option>
              <option value="PY">Paraguay</option>
              <option value="NL">Pays-Bas</option>
              <option value="PE">Pérou</option>
              <option value="PH">Philippines</option>
              <option value="PN">Pitcairn</option>
              <option value="PL">Pologne</option>
              <option value="PF">Polynésie française</option>
              <option value="PR">Porto Rico</option>
              <option value="PT">Portugal</option>
              <option value="QA">Qatar</option>
              <option value="RE">Réunion</option>
              <option value="SY">République arabe syrienne</option>
              <option value="CF">République centrafricaine</option>
              <option value="LA">République démocratique populaire lao</option>
              <option value="DO">République dominicaine</option>
              <option value="CZ">République tchèque</option>
              <option value="RO">Roumanie</option>
              <option value="GB">Royaume-Uni de Grande-Bretagne et d'Irlande du Nord</option>
              <option value="RW">Rwanda</option>
              <option value="EH">Sahara Occidenta</option>
              <option value="BL">Saint Barthélemy</option>
              <option value="SH">Sainte Hélène, Ascension et Tristan da Cunha</option>
              <option value="LC">Sainte-Lucie</option>
              <option value="KN">Saint-Kitts-et-Nevis</option>
              <option value="SM">Saint-Marin</option>
              <option value="MF">Saint-Martin (partie française)</option>
              <option value="PM">Saint-Pierre et Miquelon</option>
              <option value="VA">Saint-Siège</option>
              <option value="VC">Saint-Vincent-et-les Grenadines</option>
              <option value="AS">Samoa américaines</option>
              <option value="WS">Samoa</option>
              <option value="ST">Sao Tomé et Principe</option>
              <option value="SN">Sénégal</option>
              <option value="RS">Serbie</option>
              <option value="SC">Seychelles</option>
              <option value="SL">Sierra Leone</option>
              <option value="SG">Singapour</option>
              <option value="SX">Sint Maarten (partie néerlandaise)</option>
              <option value="SK">Slovaquie</option>
              <option value="SI">Slovénie</option>
              <option value="SO">Somalie</option>
              <option value="SS">Soudan du Sud</option>
              <option value="SD">Soudan</option>
              <option value="LK">Sri Lanka</option>
              <option value="SE">Suède</option>
              <option value="CH">Suisse</option>
              <option value="SR">Surinam</option>
              <option value="SJ">Svalbard et la mer</option>
              <option value="SZ">Swaziland</option>
              <option value="TJ">Tadjikistan</option>
              <option value="TW">Taïwan, province de Chine[a]</option>
              <option value="TZ">Tanzanie, République-Unie de</option>
              <option value="TD">Tchad</option>
              <option value="TF">Terres Australes Françaises</option>
              <option value="IO">Territoire britannique de l'océan Indien</option>
              <option value="TH">Thaïlande</option>
              <option value="TL">Timor oriental</option>
              <option value="TG">Togo</option>
              <option value="TT">Trinité-et-Tobago</option>
              <option value="TN">Tunisie</option>
              <option value="TM">Turkménistan</option>
              <option value="TR">Turquie</option>
              <option value="TV">Tuvalu</option>
              <option value="UA">Ukraine</option>
              <option value="UY">Uruguay</option>
              <option value="VU">Vanuatu</option>
              <option value="VE">Venezuela (République bolivarienne du)</option>
              <option value="VN">Viet Nam</option>
              <option value="WF">Wallis et Futuna</option>
              <option value="YE">Yémen</option>
              <option value="ZM">Zambie</option>
              <option value="ZW">Zimbabwe</option>
            </select>
        </div>
        

        <!-- <div class="input-field col s6 m6">
          <input :id="'nationalite[' + id + ']'" type="text" minlength="2" class="validate"
            pattern="^[A-z0-9\s]{2,255}$" 
            v-model="passengers.nationality[id]" />
          <label :for="'nationalite[' + id + ']'">Nationalité</label>
          <span class="helper-text" data-error="Merci de saisir la nationalité"></span>
        </div> -->


        <div class="input-field col s12 m4">
          <input :id="'villenaissance[' + id + ']'" type="text" minlength="2" class="validate"
            pattern="^[A-z-\s]{2,50}$"  
            v-model="passengers.villenaissance[id]" />
          <label :for="'villenaissance[' + id + ']'">Ville de naissance</label>
          <span class="helper-text" data-error="Merci de saisir le prénom (caractères spéciaux interdit)"></span>
        </div>


        <div class="input-field inline col s12 m6">
          
          <input :id="'passport[' + id + ']'" type="text" minlength="6" class="validate"
            pattern="^[A-z0-9\s]{2,255}$" 
            v-model="passengers.passport[id]" />
          <p class="warning">
            Attention : Votre passeport doit avoir une validité de plus de
            6 mois après la date de retour.
          </p>
          <label :for="'passport[' + id + ']'">Numéro de passeport</label>
          <!-- <span class="helper-text red-text darken-4" data-error data-success>validité du passeport de plus de 6 mois
            obligatoire</span> -->
        </div>
      </div>

      <div class="input-field col s12 right-align">
        <a id="cancelTravelers" class="action-retour">retour</a>
        <button id="validTravelers" class="waves-effect waves-light btn disabled">
          Confirmer
        </button>
      </div>
    </form>
  </div>
</template>


<script>
import InputDateBirth from "@/components/reservation/InputDateBirth.vue";
// import axios from "axios";
// import API from "../api.js";
import M from "materialize-css";
import jquery from "jquery";
let $ = jquery;

export default {
  components: {
    InputDateBirth,
  },
  data() {
    return {
      departure: null,
      destination: null,
      place: null,
      date: null,
      datereturn: null,
      codedate: null,
      codedatereturn: null,
      //      code: null,
      phone: null,
      mail: null,
      passengers: {
        firstname: [],
        lastname: [],
        birthday: [],
        nationality: [],
        paysnaissance: [],
        villenaissance: [],
        passport: [],
      },
    };
  },
  mounted() {
    $(this.$el)
      .find("form#passengers")
      .on(
        "keyup change paste",
        "input, select, textarea, option",
        function () {
          // console.log($("form#passengers").serializeArray());

          let check = this.validate();

          if (check === true) {
            document
              .querySelector("#validTravelers")
              .classList.remove("disabled");
          } else {
            console.log(check);
            document.querySelector("#validTravelers").classList.add("disabled");
          }
        }.bind(this)
      );

    this.$root.$on(
      "emit-travel",
      (
        departure,
        destination,
        place,
        date,
        datereturn,
        codedate,
        codedatereturn
      ) => {
        this.departure = departure;
        this.destination = destination;
        this.place = parseInt(place);
        this.date = date;
        this.datereturn = datereturn;
        this.codedate = codedate;
        this.codedatereturn = codedatereturn;
        // this.code = code;
      }
    );

    jquery("#passengers").on(
      "submit",
      function (e) {
        e.preventDefault();
        // validate() returns true or a string
        if (this.validate() === true) {
          this.$root.$emit("emit-travelers", this.$data);

          var instance = M.Collapsible.getInstance(jquery(".collapsible"));
          instance.open(2);
          jquery("html, body").animate({ scrollTop: 0 }, "slow");
        }
      }.bind(this)
    );

    $("#cancelTravelers").on("click", function () {
      var instance = M.Collapsible.getInstance($(".collapsible"));
      instance.open(0);
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  },
  methods: {
    numPassenger(id) {
      if (id == 1 && this.place == 1) {
        return "";
      }
      if (id == 2 && this.place == 2) {
        return "2nd ";
      }
      return id == 1 ? "1er " : `${id}ème `;
    },
    validate() {


      // Forbidden characters
      
      const dataErrorSpan = document.querySelectorAll('span[data-error]');

      for( const e of dataErrorSpan ){
        var styles = window.getComputedStyle(e,':after');

        if( styles['content'] != "\"\"" && styles['content'] != "none" ){
          return "Forbidden character";
        }
      }

      // departure
      if (this.departure.length != 2) return "departure length";

      // destination
      if (this.destination.length != 2) return "destination length";

      // place
      if (typeof this.place != "number" || this.place < 1) return "wrong place";

      // date
      if (this.date.length != 10) return "wrong date format";
      //if (!(this.date instanceof Date)) return "wrong date format";

      // date return
      // if (this.datereturn != null && this.datereturn.length != 10)
      //   return "wrong datereturn format";

      // code date
      if (this.codedate != null && this.codedate.length < 5)
        return "wrong codedate format";

      // code date return
      // if (this.codedatereturn != null && this.codedatereturn.length < 5)
      //   return "wrong codedatereturn format";

      // phone
      if (this.phone == null) return "no phone";

      // mail
      if (this.mail == null) return "no mail";
      if (this.mail.indexOf("@") == -1) return "no @ in mail";
      if (this.mail.split("@").length != 2)
        return "only one @ expected in mail";
      if (this.mail.indexOf(" ") != -1) return "unexpected spaces in mail";

      // passengers
      for (let carac in this.passengers) {
        if (carac == 'prices') break;

        let c = this.passengers[carac];

        if (c.length < this.place) return `wrong ${carac} count`;

        for (let i = 0; i < c.length; i++) {
          if (!c[i] || c[i].length < 2) return `${carac} ${i} not set`;
        }
      }

      // passports
      if (this.passengers.passport.length >= this.place) {
        for (let p in this.passengers.passport) {
          if (this.passengers.passport[p].length < 6) {
            return `passport ${p} too short`;
          }
        }
      }

      return true;
    },
  },
};
</script>


<style scoped>
.collapsible-body {
  background-color: white;
  margin-top: 105px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.87);
}

h4::first-letter {
  text-transform: uppercase;
}

p.warning {
  color: red;
}
</style>